function socialAuth(result: boolean): void {
  if (result) {
    window.close();
  }
}

export default socialAuth;
